import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { FaLaptop, FaTshirt, FaHome, FaBook, FaSpa } from "react-icons/fa";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { useSignup } from "../context/signUpContext";

const PersonalInfo = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const selectedPlan = location.state?.selectedPlan;

  const [selectedOptions, setSelectedOptions] = useState([]);
  const { setCompletedSteps } = useSignup();

  const toggleOption = (option) => {
    if (selectedOptions.includes(option)) {
      setSelectedOptions(selectedOptions.filter((item) => item !== option));
    } else {
      setSelectedOptions([...selectedOptions, option]);
    }
  };
  console.log("plani i selektum",selectedPlan);

  const handleNext = () => {
    setCompletedSteps((prev) => ({ ...prev, personalInfo: true }));
    navigate("/sign-up", {
      state: { selectedPlan, selectedOptions },
    });
  };

  return (
    <>
      <Header />
      <div className="min-h-screen p-5 flex items-center justify-center bg-white dark:bg-gray-900">
        <div className="flex flex-col md:flex-row bg-white rounded-lg shadow-lg overflow-hidden w-full md:max-w-4xl">
          <div className="bg-blue-600 p-8 flex flex-col justify-between text-white w-full md:w-1/3 dark:bg-blue-800">
            <div>
              <h2 className="text-2xl md:text-3xl font-semibold mb-6">
                Your selected plan
              </h2>
              {selectedPlan ? (
                <>
                  <h3 className="text-xl md:text-2xl font-bold">{selectedPlan.title}</h3>
                  <p className="text-lg">{selectedPlan.price}/month</p>
                  <ul className="mt-4 space-y-2">
                    {selectedPlan.features.map((feature, index) => (
                      <li key={index} className="flex items-center">
                        <FontAwesomeIcon
                          icon={faCheck}
                          className="w-6 h-6 mr-2"
                        />
                        {feature}
                      </li>
                    ))}
                  </ul>
                </>
              ) : (
                <p>No plan selected.</p>
              )}
            </div>
            <div className="mt-4">
              <a href="#" className="text-white text-sm underline">
                Go back
              </a>
            </div>
          </div>
  
          <div className="bg-white w-full md:w-2/3 p-6 md:p-12 flex flex-col justify-between dark:bg-gray-800">
            <div className="space-y-6">
              <div className="flex flex-wrap items-center justify-between">
                <div className="text-sm md:text-lg font-semibold text-blue-600 dark:text-blue-400">
                  1 Personal Info
                </div>
                <div className="text-sm md:text-lg font-semibold text-gray-300 dark:text-gray-600">
                  2 Account Info
                </div>
                <div className="text-sm md:text-lg font-semibold text-gray-300 dark:text-gray-600">
                  3 Payment
                </div>
                <div className="text-sm md:text-lg font-semibold text-gray-300 dark:text-gray-600">
                  4 Confirmation
                </div>
              </div>
  
              <div className="mt-8">
                <h3 className="text-xl md:text-2xl font-bold dark:text-white text-black">
                  Tell us about yourself
                </h3>
                <p className="mt-4 dark:text-gray-400 text-gray-600">
                  What types of products are you most interested in?
                </p>
  
                <div className="mt-6 space-y-4">
                  {[
                    { label: "Electronics", icon: FaLaptop },
                    { label: "Fashion & Clothing", icon: FaTshirt },
                    { label: "Home & Kitchen", icon: FaHome },
                    { label: "Books", icon: FaBook },
                    { label: "Beauty & Personal Care", icon: FaSpa },
                  ].map(({ label, icon: Icon }) => (
                    <button
                      key={label}
                      className={`flex items-center justify-between w-full p-4 text-left border rounded-lg ${
                        selectedOptions.includes(label)
                          ? "dark:border-blue-400 dark:text-blue-400 border-blue-600 text-blue-600"
                          : "dark:border-gray-700 dark:text-gray-400 border-gray-200 text-gray-500"
                      }`}
                      onClick={() => toggleOption(label)}
                    >
                      <div className="flex items-center">
                        <Icon className="w-6 h-6 mr-2" />
                        {label}
                      </div>
                      <FontAwesomeIcon icon={faCheck} className="w-6 h-6" />
                    </button>
                  ))}
                </div>
              </div>
            </div>
  
            <div className="mt-8">
              <button
                className="w-full p-4 bg-blue-600 text-white dark:bg-blue-500 dark:text-white rounded-lg hover:bg-blue-700"
                onClick={handleNext}
              >
                Next: Account Info
              </button>
              <p className="mt-4 text-center text-gray-500 dark:text-gray-400">
                Already have an account?{" "}
                <a
                  href="/login"
                  className="text-blue-600 dark:text-blue-400 hover:underline"
                >
                  Login here.
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
  
};

export default PersonalInfo;
